import PropTypes from "prop-types";
import React from "react";

import { Alert, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import logo from "assets/images/realtyspace-logo.png";

const Login = props => {

  //meta title
  document.title = "Admin";

  const dispatch = useDispatch();

  const validation = useFormik({

    enableReinitialize: true,

    initialValues: {
      userName: "",
      password: "",
    },
    validationSchema: Yup.object({
      userName: Yup.string().required("Please Enter Your Username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    }
  });


  const LoginProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      error: login.error
    })
  );

  const {
    error
  } = useSelector(LoginProperties);

  const signIn = type => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  //for facebook and google authentication
  const socialResponse = type => {
    signIn(type);
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  return (
    <React.Fragment>
      <div className="auth-modern-wrapper">
        <div className="auth-modern-card">
          <div className="text-center mb-3">
            <img src={logo} alt="RealtySpace" height="32" />
          </div>
          <h4 className="auth-modern-title">Welcome back</h4>
          <p className="auth-modern-subtitle">Sign in to continue to your dashboard</p>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            {error ? <Alert color="danger">{error}</Alert> : null}

            <div className="mb-3">
              <Label className="form-label">Username</Label>
              <Input
                name="userName"
                className="form-control"
                placeholder="Enter username"
                type="text"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.userName && validation.errors.userName ? true : false
                }
              />
              {validation.touched.userName && validation.errors.userName ? (
                <FormFeedback type="invalid">{validation.errors.userName}</FormFeedback>
              ) : null}
            </div>

            <div className="mb-3">
              <Label className="form-label">Password</Label>
              <Input
                name="password"
                type="password"
                placeholder="Enter Password"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.password && validation.errors.password ? true : false
                }
              />
              {validation.touched.password && validation.errors.password ? (
                <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
              ) : null}
            </div>

            <div className="mt-4 d-grid">
              <button
                className="btn btn-primary"
                type="submit"
              >
                Log In
              </button>
            </div>

            <div className="mt-3 text-center">
              <Link to="/forgot-password" className="text-muted">
                <i className="mdi mdi-lock me-1" />
                Forgot your password?
              </Link>
            </div>
          </Form>

          <div className="auth-modern-footer">
            © {new Date().getFullYear()} RealtySpace
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
